import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/storage-moving-and-student-storage.jpg'),
    alt: 'storage moving and student storage page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'storage moving and student storage page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Reliable <span>Student</span><span>Moving and Storage Solutions</span>',
  description:
    'Simplify your move with secure student storage. Whether relocating, switching dorms, or storing seasonal items, our flexible, affordable solutions keep things easy.',
  image: {
    url: '/images/v2/pages/landing-pages/storage-moving-and-student-storage/hero-image.jpg',
    alt: 'Reliable Student Moving and Storage Solutions'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Register for Moving & Storage' }
}

export const ourProcessSectionContent = {
  title: 'How Moving and Student Storage Works',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/storage-moving-and-student-storage/how-moving-and-student-storage-works.png',
    alt: 'How Moving and Student Storage Works'
  },

  articles: [
    {
      id: 1,
      title: 'Easy Booking and Scheduling',
      description:
        'Choose your storage location, pick-up date, and duration of storage through our online booking system. It’s fast and hassle-free.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-moving-and-student-storage/easy-booking-and-scheduling.png',
        alt: 'Easy Booking and Scheduling'
      }
    },
    {
      id: 2,
      title: 'Secure and Organized Storage',
      description:
        'Your belongings are stored in secure, monitored facilities with 24/7 surveillance, so you can trust that everything is in safe hands.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-moving-and-student-storage/secure-and-organized-storage.png',
        alt: 'Secure and Organized Storage'
      }
    },
    {
      id: 3,
      title: 'Flexible Access',
      description: 'Access your items whenever you need them, with flexible hours and convenient locations.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-moving-and-student-storage/flexible-access.png',
        alt: 'Flexible Access'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Fast and Reliable Student Storage Solutions',
  description:
    'ShipAndStorage offers reliable moving and student storage solutions that cater to your specific needs. Whether you’re moving homes or storing your belongings while at school, our storage services ensure a seamless experience with secure and affordable options.',
  image: {
    src: '/images/v2/pages/landing-pages/storage-moving-and-student-storage/fast-and-reliable-student-storage-solutions.jpg',
    alt: 'Fast and Reliable Student Storage Solutions'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Using Storage for Moving and Student Needs',

  cards: [
    {
      id: 1,
      title: 'Cost-Effective Solutions',
      description:
        'Our affordable pricing ensures that your move or student storage doesn’t break the bank, with flexible plans that fit every budget.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-moving-and-student-storage/cost-effective-solutions.png',
        alt: 'Cost-Effective Solutions'
      }
    },
    {
      id: 2,
      title: 'Hassle-Free Process',
      description:
        'We handle everything from packing and storage to transport and delivery, allowing you to focus on your move or academic life without stress.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-moving-and-student-storage/hassle-free-process.png',
        alt: 'Hassle-Free Process'
      }
    },
    {
      id: 3,
      title: 'Nationwide Coverage',
      description:
        'We serve both students and movers across the United States, making our services accessible no matter where you’re located.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-moving-and-student-storage/nationwide-coverage.png',
        alt: 'Nationwide Coverage'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Choose Moving and Student Storage Services?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Students Moving to College or University',
          description:
            'Whether it’s your first time moving to campus or you’re returning for another year, we offer reliable storage solutions that make the transition easier.'
        },
        {
          id: 2,
          title: 'Parents Helping Students Move',
          description:
            'Parents can rely on us to store their child’s belongings safely and securely while they’re away at school.'
        },
        {
          id: 3,
          title: 'People in the Middle of a Move',
          description:
            'Moving to a new home? Store your belongings temporarily with our secure storage solutions during your transition.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/storage-moving-and-student-storage/who-should-choose-moving-and-student-storage-services.jpg',
        alt: 'Who Should Choose Moving and Student Storage Services?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Explore Our Additional Storage Solutions',

  cards: [
    {
      id: 1,
      title: 'Business Storage Solutions',
      description:
        'Whether you’re a small business owner or need to store office items, we provide affordable business storage options.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-moving-and-student-storage/business-storage-solution.png',
        alt: 'Business Storage Solutions'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Business Storage' }
    },
    {
      id: 2,
      title: 'Moving Storage Solution',
      description: 'Store your items securely during your move, with flexible access options and no hidden fees.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-moving-and-student-storage/moving-storage-solution.png',
        alt: 'Moving Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Moving Storage' }
    },
    {
      id: 3,
      title: 'Luggage and Box Shipping Services',
      description:
        'Easily ship your luggage or boxes locally or internationally with our affordable shipping services.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-moving-and-student-storage/luggage-and-box-shipping-services.png',
        alt: 'Luggage and Box Shipping Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Box Storage' }
    },
    {
      id: 4,
      title: 'Residential Storage Services',
      description:
        'Perfect for homeowners renovating or going on vacation, our residential storage solutions keep your items safe and accessible.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-moving-and-student-storage/residential-storage-services.png',
        alt: 'Residential Storage Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Residential Storage' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose ShipAndStorage for Moving and Student Storage?',

  image: {
    url: '/images/v2/pages/landing-pages/storage-moving-and-student-storage/why-choose-shipandstorage-for-moving-and-student-storage.jpg',
    alt: 'Why Choose ShipAndStorage for Moving and Student Storage?'
  },

  articles: [
    {
      id: 1,
      title: 'Comprehensive Storage Services',
      description:
        'We offer complete storage solutions, from pickup to delivery, so you don’t have to worry about a thing.'
    },
    {
      id: 2,
      title: 'Flexible Storage Plans',
      description:
        "We offer a variety of plans to suit your storage needs, whether you’re storing a few boxes or an entire apartment's worth of items."
    },
    {
      id: 3,
      title: 'Affordable and Transparent Pricing',
      description: 'Our pricing is clear with no hidden fees, designed to fit within any budget for students or movers.'
    },
    {
      id: 4,
      title: 'Fast and Reliable Delivery',
      description:
        'With our reliable logistics partners, your items are delivered on time, ensuring a smooth move or storage experience.'
    },
    {
      id: 5,
      title: 'Secure and Safe Storage',
      description: 'Your belongings are stored in secure, monitored facilities with state-of-the-art security systems.'
    },
    {
      id: 6,
      title: 'Tailored to Students and Movers',
      description:
        'We understand the unique challenges of moving or storing for school and offer services designed specifically for students and families.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Reliable Moving and Storage Solutions for Students',
  description:
    'Reliable moving and storage solutions for students. Affordable, fast, and secure options for storing and moving your belongings.',
  image: {
    src: '/images/v2/pages/landing-pages/storage-moving-and-student-storage/reliable-moving-sand-storage-solutions-for-students.png',
    alt: 'Reliable Moving and Storage Solutions for Students'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Start Your Storage Today' }
}

export const ourPartnersSectionContent = {
  description:
    'ShipAndStorage collaborates with top global shipping and logistics providers to offer premium storage solutions.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx ensures reliable and secure storage and transportation, offering top-notch logistics to handle your items with care.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL’s global logistics network ensures the safe storage and transport of your items during your move or student storage period.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS provides secure and flexible storage and shipping services, ensuring that your items are safely stored and delivered.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.ups.com/' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
